<template>
    <div class="text-block">
        <h3 class="text-block__heading">{{ heading }}</h3>

        <div class="text-block__box">
            <slot></slot>
        </div>

        <AppButton v-if="buttonLink && buttonText" :link="buttonLink" :text="buttonText" class="text-block__button"/>
    </div>
</template>

<script>
    import AppButton from "@/components/ui/AppButton";

    export default {
        name: 'TextBlock',
        props: {
            heading: String,
            buttonText: String,
            buttonLink: String,
        },
        components: {
            AppButton,
        }
    }
</script>